import axios from "axios";
import { cmsEnv, cmsHeaders } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchContactBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/contact-us-banner`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error: any) {
    console.error("Server Error", error);
    dynamicFailed(error.response.data.error.message);
  }
};

export const fetchDistance = async () => {
  try {
    const response = await axios.get(
       `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/contact-us-distance`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    console.error("Server Error", error);
    dynamicFailed(error.response.data.error.message);
  }
};
